import React from 'react';
import { Switch, Redirect, Route } from "react-router-dom";
import HomePage from "../../HomePage";
import AdminPage from "../../AdminPage";
import UserPage from "../../UserPage";
import NotFoundPage from "../../NotFoundPage";
import DashboardPage from "../../DashboardPage";
import BasePage from "../../../base/BasePage"

import BlogEntity from "../../../entities/blog";
import RestaurantEntity from "../../../entities/restaurant";
import UserEntity from "../../../entities/user";
import OAuth from '../../OAuth';
import SettingPage from '../../SettingPage';
import ProfilePage from '../../ProfilePage';

export default function AdminRoutes(props) {
    const { user, roles, theme, openSnackbar, userData, appSettings } = props;
    const lang = appSettings ? (appSettings.language ? appSettings.language: 'en') : 'en';

    return <Switch>
        <Route path="/" exact>
            {user ? (
                <DashboardPage user={user}
                    roles={roles}
                    theme={theme}
                    appSettings={appSettings}
                    openSnackbar={openSnackbar} />
            ) : (
                    <HomePage user={user} openSnackbar={openSnackbar} />
                )}
        </Route>

        <Route path="/dashboard">
          {user ? <DashboardPage user={user} 
              roles={roles}
              theme={theme}
              userData={userData}
              appSettings={appSettings}
              openSnackbar={openSnackbar} /> : <Redirect to="/" />}
          </Route>

          <Route path="/admin">
            {user && roles.includes("admin") ? (
              <AdminPage />
            ) : (
              <Redirect to="/" />
            )}
          </Route>

          <Route path="/user/:userId">
            {user ? <UserPage /> : <Redirect to="/" />}
          </Route>

          <Route path="/restaurants" key="restaurants">
            {user ? <BasePage roles={roles} 
                meta={RestaurantEntity(lang)}
                user={user}
                theme={theme}
                appSettings={appSettings}
                openSnackbar={openSnackbar} /> : <Redirect to="/" />}
          </Route>

          <Route path="/blogs" key="blogs">
            {user ? <BasePage roles={roles} 
                meta={BlogEntity(lang)}
                user={user}
                theme={theme}
                appSettings={appSettings}
                openSnackbar={openSnackbar} /> : <Redirect to="/" />}
          </Route>

          <Route path="/users" key="users">
            {user ? <BasePage roles={roles}
                meta={UserEntity(lang)}
                user={user}
                theme={theme}
                appSettings={appSettings}
                openSnackbar={openSnackbar} /> : <Redirect to="/" />}
          </Route>

          <Route path="/settings">
            {/*user ? <BasePage roles={roles}
                meta={SettingEntity}
                user={user}
                theme={theme}
            openSnackbar={openSnackbar} /> : <Redirect to="/" />*/}
            {
              user ? <SettingPage
                      roles={roles}
                      user={user}
                      theme={theme}
                      appSettings={appSettings}
                      openSnackbar={openSnackbar}
                      /> : <Redirect to="/" />
            }
          </Route>

        <Route path="/profile" key="profile">
          {
                user ? <ProfilePage
                        roles={roles}
                        user={user}
                        theme={theme}
                        appSettings={appSettings}
                        openSnackbar={openSnackbar}
                        /> : <Redirect to="/" />
              }
          </Route>

          <Route path="/oauth">
            <OAuth roles={roles}
                user={user}
                theme={theme}
                appSettings={appSettings}
                openSnackbar={openSnackbar} />
          </Route>
        <Route>
            <NotFoundPage />
        </Route>
    </Switch>
}